export default {
  clEvents: {},
};



// WEBPACK FOOTER //
// ./src/app/cl-events/store/state.js